import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Seo from '../components/Seo';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'LearnWebCare',
  url: 'https://learnwebcare.com/',
  description:
    'Manage subscriptions, get billing assistance, request cancellations, and contact expert support agents for partner-site account help.',
  publisher: {
    '@type': 'Organization',
    name: 'LearnWebCare',
    url: 'https://learnwebcare.com/',
    logo: {
      '@type': 'ImageObject',
      url: 'https://learnwebcare.com/logo192.png',
    },
  },
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Subscription Management & Billing Support Services"
        description="Manage subscriptions, get billing assistance, request cancellations, and contact expert support agents for partner-site account help."
        canonicalUrl="https://learnwebcare.com/"
        ogTitle="Subscription Management & Billing Support Services"
        ogDescription="Manage subscriptions, get billing assistance, request cancellations, and contact expert support agents for partner-site account help."
        ogUrl="https://learnwebcare.com/"
        ogImage="https://learnwebcare.com/logo192.png"
        schema={homeSchema}
      />
      <Header />
      <Hero />
      <TrustBar />
      <Features />
      <Footer />
    </div>
  );
}
